import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/login',
}) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // If auth context is not loaded yet, show loading indicator
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  // If user is not logged in, redirect to login page
  if (!user) {
    // Save the intended path for after login
    const currentPath = encodeURIComponent(location.pathname + location.search);
    
    return (
      <Navigate
        to={`${redirectTo}?returnTo=${currentPath}`}
        replace
      />
    );
  }

  // If user is logged in, show protected content
  return <>{children}</>;
}; 